import React from 'react'
import { cn } from '@/lib/utils'

export const Media: React.FC<React.HTMLAttributes<HTMLDivElement> & { tag?: React.ElementType }> = ({
  className, tag: Tag = 'div', ...props
}) => (
  <Tag className={cn('flex items-start gap-3', className)} {...props} />
)

export const MediaBody: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div className={cn('flex-1', className)} {...props} />
)
